
(function () {
  
  const announcementBar = document.getElementById('announcement-bar-section');
  const header = document.querySelector('[data-section-type="header"]');
  const slidesTotal = announcementBar.querySelectorAll('.announcement-bar--slide').length;
  var root = document.querySelector(':root');

  if(announcementBar) {
    const swiper = new Swiper('.announcement-bar--slider', {
      // Optional parameters
      loop: slidesTotal > 1 ? true : false,
      slidesPerView: 1,
      preventClicks: false,
      autoplay: {
       delay: 8000,
     },
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function () {
          // console.log(swiper.slides.length)
          var announcement_height = announcementBar.offsetHeight;
          root.style.setProperty('--announcement-height', announcement_height+'px');
        },
      },
    });
  }

  const yotpoLoyaltyPts = document.querySelectorAll('.swell-point-balance');
  if(yotpoLoyaltyPts.length > 0) {
    let customerId = yotpoLoyaltyPts[0].dataset.customerId;
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json'
      }
    };
    
    fetch('https://loyalty.yotpo.com/api/v2/customers?customer_id='+customerId+'&country_iso_code=null&with_referral_code=false&with_history=true&guid=T61xuJ5f1iqNidF9Zewd7A&api_key=SCQF94UZoOC6cK8fIrp9wgtt', options)
      .then(res => res.json())
      .then(res => {
        yotpoLoyaltyPts.forEach(yotpoLoyaltyPtsEl => {
          var points_balance = res.points_balance;
          yotpoLoyaltyPtsEl.textContent = points_balance.toLocaleString();
        });
      })
      .catch(err => console.error(err));
  }
})();